import React from "react";
import {
  CardLeft as CardLeftWrapper,
  PracticeInfo,
  InfoTopic,
  TopicTitle,
  InfoProgressContainer,
  ProgressBar,
  ProgressFill,
  ProgressStatus,
  StatusCount,
  StatusState,
  StatusStateVariant,
  ButtonGroup,
  ActionDescription,
  TopicImage
} from "./session-card.styles";
import { Button } from "design-system/components/button/button";
import { ButtonSize } from "design-system/components/button/button.types";
import { Icon } from "design-system/components/icon/icon";
import { PracticeSessionQuestionStatus } from "services/api/practice/practiceService.types";
import MathImage from "public/assets-v2/illustrations/math.svg";

interface LeftCardSectionProps {
  questionTopic: string;
  currentQuestionNumber: number;
  numberOfQuestions: number;
  questionStatus: PracticeSessionQuestionStatus;
  primaryButtonContent: React.ReactNode;
  isPrimaryDisabled: boolean;
  onPrimaryClick: () => void;
  onExit: () => void;
  onTutorial?: () => void;
  actionDescription?: string;
}

const getStatusVariant = (
  status: PracticeSessionQuestionStatus
): StatusStateVariant => {
  if (status === PracticeSessionQuestionStatus.Correct) return "correct";
  if (status === PracticeSessionQuestionStatus.Incorrect) return "wrong";
  return "ongoing";
};

const getStatusLabel = (status: PracticeSessionQuestionStatus): string => {
  if (status === PracticeSessionQuestionStatus.Correct) return "Jawaban benar";
  if (status === PracticeSessionQuestionStatus.Incorrect)
    return "Jawaban salah";
  return "Belum dijawab";
};

export const CardLeftSection: React.FC<LeftCardSectionProps> = ({
  questionTopic,
  currentQuestionNumber,
  numberOfQuestions,
  questionStatus,
  primaryButtonContent,
  isPrimaryDisabled,
  onPrimaryClick,
  onExit,
  onTutorial,
  actionDescription
}) => {
  return (
    <CardLeftWrapper>
      <PracticeInfo>
        <InfoTopic>
          <TopicImage src={MathImage} alt="math" />
          <TopicTitle>{questionTopic}</TopicTitle>
        </InfoTopic>
        <InfoProgressContainer>
          <ProgressBar>
            <ProgressFill
              $progress={currentQuestionNumber / numberOfQuestions}
            />
          </ProgressBar>
          <ProgressStatus>
            <StatusCount>
              Soal {currentQuestionNumber}/{numberOfQuestions}
            </StatusCount>
            <StatusState $variant={getStatusVariant(questionStatus)}>
              {getStatusLabel(questionStatus)}
            </StatusState>
          </ProgressStatus>
        </InfoProgressContainer>
      </PracticeInfo>

      <ButtonGroup>
        <Button
          appearance="general"
          variant="primary"
          size={ButtonSize.lg}
          isFullWidth
          disabled={isPrimaryDisabled}
          onClick={onPrimaryClick}
        >
          {primaryButtonContent}
        </Button>
        <Button
          appearance="general"
          variant="secondary"
          size={ButtonSize.lg}
          isFullWidth
          onClick={onExit}
        >
          Keluar
        </Button>
        {actionDescription ? (
          <ActionDescription>{actionDescription}</ActionDescription>
        ) : (
          onTutorial && (
            <Button
              appearance="general"
              variant="ghost"
              size={ButtonSize.lg}
              isFullWidth
              onClick={onTutorial}
            >
              <Icon name="general-info" />
              Cara mengerjakannya
            </Button>
          )
        )}
      </ButtonGroup>
    </CardLeftWrapper>
  );
};
